"use client";

import { useState } from "react";
import { useTranslations } from "next-intl";
import SearchBar, { type StayMode } from "@/components/SearchBar";

/**
 * Hero search: the Short stay / Monthly stays pill toggle plus the shared
 * <SearchBar/>. The toggle only changes what SearchBar does in long mode
 * (Move in/out labels, 30-night minimum, `stay=long` on the URL) — /search and
 * everything after it is untouched (D-062).
 */
export default function HeroSearch() {
  const t = useTranslations("home");
  const [mode, setMode] = useState<StayMode>("short");

  const options: { value: StayMode; label: string }[] = [
    { value: "short", label: t("stayShort") },
    { value: "long", label: t("stayLong") },
  ];

  return (
    <div className="flex flex-col items-center">
      <div
        role="group"
        aria-label={t("stayGroup")}
        className="flex w-full md:inline-flex md:w-auto max-w-full gap-1 p-1 mb-3 rounded-full bg-ss-bg-soft border border-ss-line md:bg-white/15 md:border-white/30 md:backdrop-blur-md"
      >
        {options.map((o) => {
          const on = mode === o.value;
          return (
            <button
              key={o.value}
              type="button"
              aria-pressed={on}
              onClick={() => setMode(o.value)}
              className={`flex-1 md:flex-none rounded-full px-3 md:px-4 py-2.5 md:py-2 text-[13.5px] font-semibold whitespace-nowrap transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ss-blue md:focus-visible:ring-white ${
                on
                  ? "bg-ss-blue text-white md:bg-white md:text-ss-text"
                  : "text-ss-text md:text-white md:hover:bg-white/10"
              }`}
            >
              {o.label}
            </button>
          );
        })}
      </div>

      {/* text-start: the hero column is centred, the search fields are not.
          The deeper shadow sits on the desktop bar only (the phone pill keeps
          its own). */}
      <div className="w-full text-start rounded-full border border-ss-line md:border-0 md:rounded-[22px] md:shadow-[0_24px_60px_-16px_rgba(11,18,51,.6)]">
        <SearchBar stayMode={mode} />
      </div>
    </div>
  );
}
